import React, { useState } from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'react-bootstrap';

import Icon from '../../../icon/Icon';
import { DATE_FORMAT_EU_DOT } from '../../../../core/constants/date';
import ConfirmModal from '../../../../pages/components/confirm-modal/ConfirmModal';

import './FileDetails.scss';

export interface FileDetailsModel {
  id: number;
  filename: string;
  location: string;
  uploadedAt: string;
  uploadedBy: string;
}

interface Props {
  uploadInProgress: boolean;
  uploadProgress: number;
  uploadingFilename: string;
  fileDetails?: FileDetailsModel;
  onRemove?: () => void;
  removeModal?: {
    titleText: string;
    contentText: string;
  };
}

const FileDetails: React.FC<Props> = ({ uploadInProgress, uploadProgress, uploadingFilename, fileDetails, onRemove, removeModal }) => {
  const { t } = useTranslation();
  const [isConfirmVisible, setConfirmVisible] = useState(false);

  return (
    <div className="file-details">
      <div className="file-details__icon">
        <Icon icon="file" size="full-size" svg />
      </div>
      <div className="file-details__content">
        <p className={`file-details__name ${uploadInProgress ? 'file-details__name--uploading' : ''}`}>
          {uploadInProgress ? uploadingFilename : fileDetails?.filename}
        </p>
        {uploadInProgress ? (
          <ProgressBar now={uploadProgress} />
        ) : (
          <p className="file-details__details">
            {t('file.uploaded')} {format(new Date(fileDetails?.uploadedAt ?? ''), DATE_FORMAT_EU_DOT)} {t('common.by')}{' '}
            <span className="file-details__uploaded-by">{fileDetails?.uploadedBy}</span>
            <Icon isButton icon="x" className="file-details__remove" onClick={() => setConfirmVisible(true)} svg />
          </p>
        )}
      </div>
      <ConfirmModal
        titleText={removeModal?.titleText}
        contentText={removeModal?.contentText}
        isOpen={isConfirmVisible}
        onCancel={() => setConfirmVisible(false)}
        onConfirm={() => {
          if (removeModal && onRemove) {
            onRemove();
          }
          setConfirmVisible(false);
        }}
      />
    </div>
  );
};

export default FileDetails;
